import { defineRoutes } from '../utils';
import type { PaymentMode } from '@hero/hooks-shared';

/**
 * Wallet domain routes — wallet page and payment flow entry.
 */
export const walletRoutes = defineRoutes({
  wallet: {
    path: '/wallet',
    isPublic: false,
    params: {} as {
      /** Payment mode to open (invoice, select, advance) */
      pay?: PaymentMode;
      /** Comma-joined invoice IDs for pre-selection */
      invoiceIds?: string[];
    },
  },
});
